export function getIdentifierByType(identifiers, types = []) {
  const length = identifiers?.content?.length;
  if (!length || length <= 0) return null;

  for (let i = 0; i < length; i++) {
    const identifier = identifiers?.content[i];
    const { identifierType, value } = identifier || {};
    if (types.includes(identifierType.key)) {
      return value;
    }
  }

  return null;
}

export function getIdentifierMatch(identifiers, type) {
  const length = identifiers?.content?.length;
  if (!length || length <= 0) return null;

  for (let i = 0; i < length; i++) {
    const identifier = identifiers?.content[i];
    const { identifierType } = identifier || {};
    if (type===identifierType.key) {
      return true;
    }
  }
  return false;
}